import {
    getPlannerItemAsync,
    PlannerQueryParams,
    queryPlannerItemsAsync,
    queryPlannerCategoriesAsync,
    PlannerCategoriesQueryParams,
    queryPlannerBoardsAsync,
    queryPlannerLabelsAsync,
} from "src/api/plannerApi";

import {
    PlannerActionTypes,
    PlannerFileAddedAction,
    AppendPlannerItemsAction,
    QueryPlannerBoardsAction,
    QueryPlannerCategoriesAction,
    QueryPlannerItemsAction,
    QueryPlannerLabelsAction
} from "../types";
import { CancelToken } from "axios";

export function plannerItemCreated(item: Spintr.PlannerItem) {
    return {
        type: PlannerActionTypes.PlannerItemCreated,
        item,
    };
}

export function plannerItemUpdated(item: Spintr.PlannerItem) {
    return {
        type: PlannerActionTypes.PlannerItemUpdated,
        item,
    };
}

export function plannerFileAdded(file: Spintr.PlannerItemFile): PlannerFileAddedAction {
    return {
        type: PlannerActionTypes.PlannerFileAdded,
        file,
    };
}

export function queryPlannerCategories(
    params?: PlannerCategoriesQueryParams | undefined,
    cancelToken?: CancelToken | undefined,
): QueryPlannerCategoriesAction {
    return {
        payload: queryPlannerCategoriesAsync(params, cancelToken),
        type: PlannerActionTypes.QueryPlannerCategories,
    };
}

export function queryPlannerItems(
    params?: PlannerQueryParams | undefined,
): QueryPlannerItemsAction {
    return {
        payload: queryPlannerItemsAsync(params),
        type: PlannerActionTypes.QueryPlannerItems,
    };
}

export function findPlannerItem(id: number) {
    return {
        payload: getPlannerItemAsync(id),
        type: PlannerActionTypes.FindPlannerItem,
    };
}

export function queryPlannerBoards(): QueryPlannerBoardsAction {
    return {
        payload: queryPlannerBoardsAsync(),
        type: PlannerActionTypes.QueryPlannerBoards,
    };
}

export function plannerBoardCreated(item: Spintr.PlannerBoard) {
    return {
        type: PlannerActionTypes.PlannerBoardCreated,
        item,
    };
}

export function plannerBoardDeleted(id: number) {
    return {
        type: PlannerActionTypes.PlannerBoardDeleted,
        id,
    };
}

export function plannerBoardUpdated(item: Spintr.PlannerBoard) {
    return {
        type: PlannerActionTypes.PlannerBoardUpdated,
        item,
    };
}

export function queryPlannerLabels(): QueryPlannerLabelsAction {
    return {
        payload: queryPlannerLabelsAsync(),
        type: PlannerActionTypes.QueryPlannerLabels,
    };
}

export function toggleDisplayBoardAction(boardId: number) {
    return {
        type: PlannerActionTypes.ToggleBoardIsHidden,
        boardId,
    };
}

export function appendPlannerItems(items: Spintr.PlannerItem[]): AppendPlannerItemsAction {
    return {
        type: PlannerActionTypes.AppendPlannerItems,
        items,
    };
}
